/**
 * Emoji ranges Safari 15 can compile. Property escapes for Extended_Pictographic
 * throw while the pattern is built on Safari 15 and some Safari 16 releases,
 * which blanks the page the first time a title is drawn.
 */
export const emojiPatternSource =
  "[\\u{1F000}-\\u{1F0FF}\\u{1F1E6}-\\u{1F1FF}\\u{1F300}-\\u{1FAFF}\\u{2300}-\\u{23FF}\\u{2600}-\\u{27BF}\\u{2B00}-\\u{2BFF}]";

let emojiPattern: RegExp | null | undefined;

/** Remove emoji from text shown in the UI. Stored Notion values stay unchanged. */
export function plainText(value: string | null | undefined): string {
  if (!value) return "";
  return stripMarks(stripEmoji(value))
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+\n/g, "\n")
    .trim();
}

function stripMarks(value: string): string {
  let out = "";
  for (const char of value) {
    const code = char.codePointAt(0) ?? 0;
    if (code === 0xfe0f || code === 0x200d) continue;
    out += char;
  }
  return out;
}

function stripEmoji(value: string): string {
  const pattern = emojiPattern === undefined ? (emojiPattern = compileEmoji()) : emojiPattern;
  if (!pattern) return value;
  return value.replace(pattern, "");
}

function compileEmoji(): RegExp | null {
  try {
    return new RegExp(emojiPatternSource, "gu");
  } catch {
    return null;
  }
}
